<template>
  <div class="page-container">
    <div class="class-form-head">创建服务协议</div>
    <div class="main">
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="150"
      >
        <div v-if="!agreementId">
          <FormItem label="创建类型:" prop="name">
            <RadioGroup
              v-model="formValidate.createType"
              @on-change="onRadioChange"
            >
              <Radio label="1">
                <span>按区域模式创建（教育局模板）</span>
              </Radio>
              <ChooseEdu
                ref="chooseEduRef"
                :disabled="formValidate.createType == 2"
                style="margin-right: 16px"
                @on-change="onEduChange"
              ></ChooseEdu>
              <Radio label="2">
                <span>按单校模式创建（单校模板）</span>
                <ChooseApply
                  ref="chooseSchoolRef"
                  :placeholder="`请选择学校`"
                  :year-term-code="[formValidate.yearCode, formValidate.termCode]"
                  :clearable="false"
                  :org-type="`1`"
                  :disabled="formValidate.createType == 1"
                  @on-change="onSchChange"
                ></ChooseApply>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="平台服务协议学期:" prop="name">
            <div style="width: 200px">
              <CascaderYearTerms
                ref="cascaderYearTerms"
                :placeholder="`请选择学期`"
                @on-change="onCascaderChange"
                @getSelectTermName="getSelectTermName"
              ></CascaderYearTerms>
            </div>
            <div>
              <strong>提示：</strong>
              <div
                v-if="formValidate.createType == 1"
                class="color-gray"
                style="font-size: 13px"
              >
                <p class="color-gray" style="font-size: 13px">
                  ①{{ formValidate.bureauOrgName }} 在
                  {{ yearTermStr }}，共有【<span class="color-red">{{
                    orgTotal
                  }}</span>】家机构 (<span
                    class="color-blue cursor-pointer"
                    @click="handleOrgList(4)"
                  >查看明细</span>)、【<span class="color-red">{{ schTotal }}</span>】所学校参与课后服务（<span
                    class="color-blue cursor-pointer"
                    @click="handleOrgList(1)"
                  >查看明细</span>），详细情况，可浏览教育局端，【基础信息中心】-【学期服务机构管理】，进行查看。
                </p>
                <p class="color-gray" style="font-size: 13px">
                  ②学期创建后不支持修改。系统将通过学校 * 机构
                  进行自动生成每个学校所有机构的服务协议。
                </p>
              </div>
              <div v-else class="color-gray" style="font-size: 13px">
                <p class="color-gray" style="font-size: 13px">
                  ① {{ schoolName }}，共有【<span class="color-red">{{
                    schOrgTotal
                  }}</span>】家机构提供服务(<span
                    class="color-blue cursor-pointer"
                    @click="handleGetSchRelOrg(4)"
                  >查看明细</span>)
                </p>
                <p class="color-gray" style="font-size: 13px">
                  ② 学期创建后不支持修改
                </p>
              </div>
            </div>
          </FormItem>
          <FormItem
            v-if="formValidate.createType == 1"
            label="学期适用学校类型:"
            prop="name"
          >
            <div class="flex align-items">
              <RadioGroup v-model="formValidate.schoolType">
                <Radio label="0">全部学校</Radio>
                <Radio label="1">指定学校</Radio>
              </RadioGroup>

              <div class="school-name">
                <p>{{ schoolStr }}</p>
                <Button
                  class="btn"
                  type="primary"
                  size="small"
                  :disabled="formValidate.schoolType == 0"
                  @click="handleOpenSchool"
                >选择</Button>
              </div>
            </div>
            <p class="color-gray" style="font-size: 13px">
              设置后不支持修改类型
            </p>
          </FormItem>
          <FormItem
            v-if="formValidate.createType == 2"
            label="服务协议适用机构:"
            prop="name"
          >
            <div class="flex text-align_center">
              <span>已选 {{ formValidate.selectOrgList.length }} 家</span>
              <Button
                type="primary"
                size="small"
                style="margin-left: 10px"
                @click="handleChooseOrg"
              >选择机构</Button>
            </div>
          </FormItem>
        </div>
        <div v-else>
          <BaseInfo :detail-info="detailInfo"></BaseInfo>
        </div>
        <FormItem label="协议模板状态:" prop="name">
          <RadioGroup v-model="formValidate.templateSts">
            <Radio label="1">启用</Radio>
            <Radio label="0">停用</Radio>
          </RadioGroup>
          <p class="color-gray" style="font-size: 13px">
            启用后，家长端订购课程前，必须先签署平台服务内容后才能选课。
          </p>
        </FormItem>
        <FormItem label="是否手写签名:" prop="name">
          <RadioGroup v-model="formValidate.isSign">
            <Radio label="1">是，必须要手写签名</Radio>
            <Radio label="0">否，不需要</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="模板类型:" prop="name">
          <RadioGroup
            v-model="formValidate.templateType"
            :disabled="!!agreementId"
          >
            <Radio label="1">服务协议-PDF版本</Radio>
            <Radio v-if="false" label="2">服务协议-富文本版</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="选择服务模板:" prop="name">
          <Select
            v-model="formValidate.templateId"
            style="width: 200px"
            :disabled="!!agreementId"
            @on-change="handleTempChange"
          >
            <Option
              v-for="item in fileTempList"
              :key="item.codeValue"
              :value="item.codeValue"
            >{{ item.codeName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="模板示例:" prop="name">
          <ViewPdfPanel ref="viewPdfPanelRef"></ViewPdfPanel>
          <p class="color-gray" style="font-size: 13px">
            提示：此模板仅做展示作用，实际生成的电子服务协议以系统为准。
          </p>
        </FormItem>
        <FormItem label="家长端预览协议:" prop="name">
          <div class="rich-text-block" :style="{ height: '500px' }">
            <div class="rich-left scroll-430">
              <div class="rich-left-title">可用变量对照表</div>
              <div
                v-for="(item, index) in variableList"
                :key="index"
                class="left-block"
              >
                <div class="left-block-title">{{ item.name }}</div>
                <div
                  v-for="x in item.list"
                  :key="x.variable"
                  class="left-block-item"
                >
                  <span>{{ x.name }}</span>
                  <span>{{ x.variable }}</span>
                </div>
              </div>
            </div>
            <div class="rich-right">
              <EditorV5 ref="editorV5"></EditorV5>
              <p class="color-gray" style="font-size: 13px">
                提示：此内容将在【{{ projectName }}】家长端选课时进行预览！
              </p>
              <div class="flex justify-content_end">
                <Button @click="handleViewHtml()">预览协议</Button>
              </div>
            </div>
          </div>
        </FormItem>
      </Form>
    </div>
    <div class="footer-main">
      <div class="flex justify-content" style="margin-left: -22%">
        <Button
          style="margin-right: 50px"
          @click="handleCancel('formValidate')"
        >取消</Button>
        <Button type="primary" @click="handleCfm('formValidate')">{{
          agreementId ? '保存' : '保存并创建'
        }}</Button>
      </div>
    </div>
    <!-- <Modal v-model="showTips" title="提示" @on-ok="ok" @on-cancel="cancel">
      <div class="main">
        <p>
          设置成功：<span class="color-green"></span> 个，失败：<span
            class="color-red"
          ></span>
          个
        </p>
        <h2>创建失败的服务协议</h2>
        <ul>
          <li>
            <span style="margin-right: 20px"></span>
            <span class="color-red">原因：</span>
          </li>
        </ul>
      </div>
      <div slot="footer">
        <div class="flex justify-content_end">
          <div>
            <Button type="primary" size="small" long @click="handleModalCfm"
              >确定</Button
            >
          </div>
        </div>
      </div>
    </Modal> -->
    <ViewOrgModal
      ref="viewOrgModalRef"
      :year-code="formValidate.yearCode"
      :term-code="formValidate.termCode"
      :bureau-org-id="formValidate.bureauOrgId"
      :edu-area-name="eduAreaName"
    ></ViewOrgModal>
    <ChooseOrg
      ref="chooseOrgRef"
      :year-code="formValidate.yearCode"
      :term-code="formValidate.termCode"
      :bureau-org-id="formValidate.bureauOrgId"
      :edu-area-name="eduAreaName"
      :year-term-str="yearTermStr"
      :org-type="formValidate.createType == 1 ? 1 : 4"
      @on-finish="onChooseOrgFinish"
    ></ChooseOrg>
    <ViewSchoolRelOrgModal
      ref="viewSchoolRelOrgModalRef"
      :school-id="formValidate.schoolId"
    ></ViewSchoolRelOrgModal>
    <ChooseSchoolRelOrg
      ref="chooseSchoolRelOrgRef"
      :school-id="formValidate.schoolId"
      :now-select-school-info="nowSelectSchoolInfo"
    >
    </ChooseSchoolRelOrg>
    <ViewHtml ref="viewHtmlRef"></ViewHtml>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';
import ChooseEdu from '@c/searchBlock/ChooseEdu.vue';
import EditorV5 from '@c/Base/EditorV5';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import ViewPdfPanel from './ViewPdfPanel.vue';
import platformApi from '@/request/eduCenter/platform.js';
import { variableList } from './components/data/index';
import ViewOrgModal from './components/ViewOrgModal.vue';
import ChooseOrg from './components/ChooseOrg.vue';
import ViewSchoolRelOrgModal from './components/ViewSchoolRelOrgModal.vue';
import ChooseSchoolRelOrg from './components/ChooseSchoolRelOrg.vue';
import BaseInfo from './components/BaseInfo.vue';
import ViewHtml from './components/ViewHtml.vue';
import { mapMutations } from 'vuex';
export default {
  components: {
    ChooseApply,
    ChooseEdu,
    CascaderYearTerms,
    EditorV5,
    ViewPdfPanel,
    ViewOrgModal,
    ChooseOrg,
    ViewSchoolRelOrgModal,
    ChooseSchoolRelOrg,
    BaseInfo,
    ViewHtml

  },
  data() {
    return {
      showTips: false,
      agreementId: this.$route.query.agreementId,
      formValidate: {
        createType: '1',
        yearCode: '',
        termCode: '',
        schoolType: '0',
        templateSts: '1',
        isSign: '1',
        templateType: '1',
        bureauOrgId: '',
        bureauOrgName: '',
        templateId: '',
        schoolId: '',
        schoolIdList: [],
        orgList: [],
        content: '',
        selectOrgList: [] // 选的学校 或者机构
      },
      schoolName: '',
      eduAreaName: '',
      orgTotal: 0,
      schTotal: 0,
      schOrgTotal: 0,
      fileTempList: [],
      yearTermStr: '',
      variableList: variableList,
      ruleValidate: {
        name: [
          { required: true, message: '', trigger: 'blur' }
        ]
      },
      detailInfo: null,
      nowSelectSchoolInfo: {} // 选中的学校
    };
  },
  computed: {
    ...mapState(['projectName']),
    schoolStr() {
      return this.formValidate.selectOrgList.map(item => { return item.orgName; }).join('、');
    }
  },
  created() {
    if (this.agreementId) {
      this.getTemplateDetail();
    } else {
      this.getDefaultTemplate();
    }
    this.getByCodeType();
  },
  methods: {
    ...mapMutations([
      'CLOSE_BROWSINGHISTORYLIST',
      'DELETE_CACHEROUTE'
    ]),
    async getByCodeType() {
      const res = await platformApi.getByCodeType({
        codeType: 'SERVICE_AGREEMENT_PDF_FILE'
      });
      if (res.status == 200) {
        this.fileTempList = res.message;
      }
    }, //

    // 获取详情
    async getTemplateDetail() {
      const res = await platformApi.getServiceAgreementTemplateDetail({
        agreementId: this.agreementId
      });

      if (res.status == 200) {
        this.detailInfo = res.message;
        this.fillForm(res.message);
      }
    },
    // 详情回填
    fillForm(info) {
      this.formValidate.templateSts = String(info.templateSts);
      this.formValidate.isSign = String(info.isSign);
      this.formValidate.templateType = String(info.templateType);
      this.formValidate.templateId = String(info.templateId);
      this.$refs.viewPdfPanelRef.handleInit(info.templateId);
      setTimeout(() => {
        this.$refs.editorV5.setEditorContext(info.content);
      }, 500);
    },
    onRadioChange() {
      console.log('123');
      this.formValidate.selectOrgList = [];
    },
    async getEduRelOrg(orgType) {
      return new Promise(async(resolve, reject) => {
        if (!this.formValidate.bureauOrgId) {
          resolve(0);
          return null;
        }
        const res = await platformApi.getEduRelOrg({
          yearCode: this.formValidate.yearCode,
          termCode: this.formValidate.termCode,
          pageNum: 1,
          pageSize: 10,
          educationBureauId: this.formValidate.bureauOrgId,
          orgName: '',
          orgType: orgType
        });
        if (res.status == 200) {
          resolve(res.message.total);
        }
      });
    },
    async getSchoolRelOrg(orgType) {
      const res = await platformApi.getSchoolRelOrg({
        pageNum: 1,
        pageSize: 10,
        schoolId: this.formValidate.schoolId,
        orgName: '',
        orgType: orgType
      });
      this.tableLoading = false;
      if (res.status == 200) {
        this.schOrgTotal = Number(res.message.total);
      }
    },
    async onCascaderChange(val) {
      this.formValidate.yearCode = val[0];
      this.formValidate.termCode = val[1];
      this.orgTotal = await this.getEduRelOrg(4);
      this.schTotal = await this.getEduRelOrg(1);
    },
    getSelectTermName(str) {
      this.yearTermStr = str;
    },
    handleOpenSchool() {
      if (!this.formValidate.bureauOrgId) {
        this.$Message.warning('请先选择教育局');
        return null;
      }
      this.$refs.chooseOrgRef.open(this.formValidate.selectOrgList);
    },
    async onEduChange(eduInfo) {
      this.formValidate.bureauOrgId = eduInfo.eduId;
      this.formValidate.bureauOrgName = eduInfo.eduName;
      this.orgTotal = await this.getEduRelOrg(4);
      this.schTotal = await this.getEduRelOrg(1);
      this.eduAreaName = eduInfo.areaName;
      console.log(eduInfo);
    },
    onSchChange(info) {
      console.log(info, 'info');
      this.nowSelectSchoolInfo = Object.assign({}, info, { name: info.orgName });
      this.schoolName = info.orgName;
      this.formValidate.schoolId = info.orgId;

      // this.formValidate.selectOrgList = [];
      this.formValidate.selectOrgList.length > 0 ? this.formValidate.selectOrgList.splice(0, this.formValidate.selectOrgList.length) : '';
      this.getSchoolRelOrg(4);
    },
    handleTempChange(val) {
      this.$refs.viewPdfPanelRef.handleInit(val);
    },
    handleOrgList(orgType) {
      if (!this.formValidate.bureauOrgId) {
        this.$Message.warning('请先选择教育局');
        return null;
      }
      this.$refs.viewOrgModalRef.handleInit(orgType);
    },
    handleGetSchRelOrg(orgType) {
      if (!this.formValidate.schoolId) {
        this.$Message.warning('请先选择学校');
        return null;
      }
      this.$refs.viewSchoolRelOrgModalRef.handleInit(orgType);
    },
    handleChooseOrg() {
      if (!this.formValidate.schoolId) {
        this.$Message.warning('请先选择学校');
        return null;
      }
      this.$refs.chooseSchoolRelOrgRef.open(this.formValidate.selectOrgList);
    },
    handleCancel() {
      this.handleGoBack();
    },
    onChooseOrgFinish(orgList) {
      this.formValidate.selectOrgList = orgList;
    },
    handleCfm() {
      const result = this.agreementId ? this.checkEditForm() : this.checkForm();
      if (result.code != 200) {
        this.$Message.warning(result.error);
        return null;
      }
      if (this.agreementId) {
        this.editServiceAgreementTemplate();
      } else {
        this.addServiceAgreementTemplate();
      }
    },
    checkEditForm() {
      this.formValidate.content = this.$refs.editorV5.getEditorContext();
      const { content } = this.formValidate;
      if (!content) {
        return {
          error: '请输入家长端预览协议',
          code: 500
        };
      }
      return {
        code: 200
      };
    },
    checkForm() {
      this.formValidate.content = this.$refs.editorV5.getEditorContext();

      const { bureauOrgId, templateId, yearCode, termCode, templateType, schoolType, isSign, templateSts, content, createType, schoolId } = this.formValidate;
      let schoolIdList = []; let orgList = [];
      if (createType == 1 && schoolType != 0) {
        schoolIdList = this.formValidate.selectOrgList.map(item => { return item.orgId; });
        this.formValidate.schoolIdList = schoolIdList;
      }
      if (createType == 2) {
        orgList = this.formValidate.selectOrgList.map(item => { return item.orgId; });
        this.formValidate.orgList = orgList;
      }
      if (createType == 1 && !bureauOrgId) {
        return {
          error: '请选择教育局',
          code: 500
        };
      }
      if (createType == 2 && !schoolId) {
        return {
          error: '请选择学校',
          code: 500
        };
      }
      if (!yearCode || !termCode) {
        return {
          error: '请选择学期',
          code: 500
        };
      }
      if (createType == 1 && schoolType != 0 && schoolIdList.length == 0) {
        return {
          error: '请选择指定学校',
          code: 500
        };
      }
      if (createType == 2 && orgList.length == 0) {
        return {
          error: '请选择机构',
          code: 500
        };
      }
      if (!templateId) {
        return {
          error: '请选择服务模版',
          code: 500
        };
      }
      if (!content) {
        return {
          error: '请输入家长端预览协议',
          code: 500
        };
      }
      return {
        code: 200
      };
    },
    getParameter() {
      const { bureauOrgId, templateId, yearCode, termCode, templateType, isSign, templateSts, content, createType, schoolId, orgList, schoolIdList } = this.formValidate;
      return {
        bureauOrgId, templateId, yearCode, termCode, templateType, isSign, templateSts, content, createType, schoolId, orgList, schoolIdList
      };
    },
    handleModalCfm() {

    },
    handleGoBack() {
      this.CLOSE_BROWSINGHISTORYLIST(this.$route.name);
      this.$router.push({
        name: 'eduCenter_platform_agreementManage'
      });
    },

    async getDefaultTemplate() {
      const res = await platformApi.getDefaultTemplate();
      if (res.status == 200) {
        setTimeout(() => {
          this.$refs.editorV5.setEditorContext(res.message);
        }, 500);
      }
    },
    async editServiceAgreementTemplate() {
      const rarameter = {
        agreementId: this.agreementId,
        isSign: this.formValidate.isSign,
        templateSts: this.formValidate.templateSts,
        content: this.formValidate.content
      };
      this.$Spin.show();
      const res = await platformApi.editServiceAgreementTemplate(rarameter);
      this.$Spin.hide();
      if (res.status == 200) {
        this.$Message.success('编辑成功');
        this.handleGoBack();
      }
    },
    async addServiceAgreementTemplate() {
      const rarameter = this.getParameter();
      this.$Spin.show();
      const res = await platformApi.addServiceAgreementTemplate(rarameter);
      this.$Spin.hide();
      if (res.status == 200) {
        this.$Message.success('添加成功');
        this.DELETE_CACHEROUTE('platformAgreementManage');
        this.handleGoBack();
      }
    },
    handleViewHtml() {
      this.formValidate.content = this.$refs.editorV5.getEditorContext();
      this.$refs.viewHtmlRef.handleShow(this.formValidate.content);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 20px 20px 100px;
  .main {
    /deep/ .ivu-radio-wrapper {
      display: flex;
      align-items: center;
    }
    /deep/ .ivu-radio-group {
      display: flex;
    }
  }
}
.class-form-head {
  background: rgba(0, 0, 0, 0.05);
  padding: 16px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-left: 24px;
}
.school-name {
  position: relative;
  border: 1px solid #eee;
  border-radius: 6px 0 0 6px;
  width: 300px;
  height: 26px;
  line-height: 26px;

  > p {
    color: #ccc;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 8px;
  }

  .btn {
    position: absolute;
    right: -44px;
    top: 0;
  }
  .checkbox {
    position: absolute;
    right: -114px;
    top: 0;
  }
}
.rich-text-block {
  display: flex;
  box-sizing: border-box;
  padding-bottom: 50px;
  position: relative;
  .btn-block {
    box-sizing: border-box;
    // border-top: 1px solid #ccc;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    button + button {
      margin-left: 40px;
    }
  }
  .rich-left {
    width: 18%;
    flex-shrink: 0;
    border: 1px solid #ccc;
    padding: 0 8px 8px 8px;
    height: 100%;
    overflow-y: scroll;
    margin-right: 4%;
    .rich-left-title {
      font-weight: bold;
      font-size: 20px;
      padding: 24px;
      border-bottom: 1px solid #eee;
      text-align: center;
    }
    .left-block-title {
      font-size: 16px;
      color: #999;
      line-height: 24px;
      margin: 16px 0;
    }
    .left-block-item {
      span {
        display: inline-block;
        width: 45%;
        font-size: 14px;
        line-height: 20px;
        word-break: break-all;
        vertical-align: top;
      }
      span + span {
        margin-left: 10%;
      }
    }
    .left-block-item + .left-block-item {
      margin-top: 8px;
    }
  }
  .rich-right {
    height: 100%;
    position: relative;
  }
}
.footer-main {
  position: fixed;
  bottom: 0;
  width: 105%;
  background-color: #fff;
  z-index: 99;
  padding: 20px 0;
  border-top: 1px solid #eee;
}
</style>
